import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { calculateLegendWidth } from '../helpers';

const RADIAL_MARGIN_PERCENT = 0.175;

export const DEFAULT_MARGINS = {
  SMALL: 60,
  MEDIUM: 100,
  LARGE: 130,
};

export function useMargins({ width, height, compact, radial = false }) {
  const { get, meta } = useReportConfiguration();
  const defaultMargin = compact ? 70 : 100;
  const expandedMargin = defaultMargin * 1.2;

  const showLegend = get('legendAnchor') && !meta.hideLegend;
  const legendWidth = showLegend ? calculateLegendWidth({ meta, width }) : 0;

  const radialMargin = useRadialMargins({
    defaultMargin,
    width,
    height,
    legendWidth,
  });

  const rectangularMargin = useRectangularMargins({
    expandedMargin,
    showLegend,
    legendWidth,
    compact,
  });

  return radial ? radialMargin : rectangularMargin;
}

function useRadialMargins({ defaultMargin, width, height, legendWidth }) {
  const verticalMargin = Math.max(
    defaultMargin,
    height * RADIAL_MARGIN_PERCENT
  );
  const horizontalMargin = Math.max(
    defaultMargin,
    width * RADIAL_MARGIN_PERCENT
  );

  return {
    top: verticalMargin,
    right: legendWidth
      ? Math.max(horizontalMargin, legendWidth + 50)
      : horizontalMargin,
    left: horizontalMargin,
    bottom: verticalMargin,
  };
}

function useRectangularMargins({ showLegend, legendWidth }) {
  const { get, meta } = useReportConfiguration();

  const top =
    get('chartTitle') && !meta.hideTitle
      ? DEFAULT_MARGINS.MEDIUM
      : DEFAULT_MARGINS.SMALL;

  const left = get(['verticalAxis', 'enabled'])
    ? get(['verticalAxis', 'title'])
      ? DEFAULT_MARGINS.LARGE
      : DEFAULT_MARGINS.MEDIUM
    : DEFAULT_MARGINS.SMALL;

  const bottom = get(['horizontalAxis', 'enabled'])
    ? get(['horizontalAxis', 'title'])
      ? DEFAULT_MARGINS.LARGE
      : DEFAULT_MARGINS.MEDIUM
    : DEFAULT_MARGINS.SMALL;

  const right = showLegend
    ? Math.max(DEFAULT_MARGINS.MEDIUM, legendWidth + DEFAULT_MARGINS.MEDIUM / 2)
    : DEFAULT_MARGINS.SMALL;

  return { top, left, bottom, right };
}
